import React from 'react'
import ReactDOM from 'react-dom/client'
import { App as AntdApp, ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import 'dayjs/locale/zh-cn'
import App from './App'
import { MessageBridge } from './components/MessageBridge'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#6366f1',
          colorLink: '#6366f1',
          fontSize: 14,
          borderRadius: 8,
        },
      }}
    >
      <AntdApp message={{ maxCount: 3 }}>
        <MessageBridge />
        <App />
      </AntdApp>
    </ConfigProvider>
  </React.StrictMode>,
)
